export const feedTypes = {
  unread: "unread",
  read: "read",
  all: "all"
};
